import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const { token, userId } = useSelector((state) => state.user);
  const location = useLocation();

  const isAuthenticated = token || userId;

  if (!isAuthenticated) {
    const params = new URLSearchParams(location.search);
    if (["/dashboard-switcher", "/profile-details"].includes(location.pathname) && (/^\d+$/.test(params.get("profileId") || "") || /^\d+$/.test(params.get("dogId") || ""))) {
      sessionStorage.setItem("pending_shared_profile", location.pathname + location.search);
    }
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
